'use client';

import Image from 'next/image';
import CopyrightFooter from '@/components/auth/CopyrightFooter';
import { motion } from 'framer-motion';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className='flex min-h-screen w-full flex-col lg:flex-row'>
      {/* Logo */}
      <motion.div
        className='p-4 lg:absolute lg:z-10'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Image
          src='/TAJ ALSAFA® Logo.svg'
          alt='Taj Al-Safa Logo'
          width={160}
          height={45}
          priority
          loading='eager'
        />
      </motion.div>

      {/* Left side - Auth Content */}
      <div className='flex min-h-screen w-full flex-col items-center justify-between px-4 pt-16 pb-8 lg:w-2/3 lg:pt-0 lg:pb-6 xl:w-7/10'>
        <div className='flex w-full flex-1 items-center justify-center'>
          <div className='w-full max-w-sm md:max-w-md'>
            {/* Content Box - This is where each auth component will render */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, staggerChildren: 0.1 }}
            >
              {children}
            </motion.div>
          </div>
        </div>

        {/* Copyright Footer - positioned at bottom using flexbox */}
        <div className='w-full flex-shrink-0'>
          <CopyrightFooter />
        </div>
      </div>

      {/* Right Section - TAJ ALSAFA Seal */}
      <div
        className='relative hidden lg:flex lg:w-1/3 lg:items-center lg:justify-center xl:w-3/10'
        style={{
          background:
            'repeating-linear-gradient(90deg, #00413D 0px, #00413D 30px, #001917 30px, #001917 40px)'
        }}
      >
        <motion.div
          className='flex items-center justify-center'
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <Image
            src='/Seals - TAJ ALSAFA®-02.svg'
            alt='TAJ ALSAFA Seal'
            width={350}
            height={350}
            priority
            className='opacity-100 transition-opacity duration-300 hover:opacity-80'
            style={{
              filter:
                'brightness(0) saturate(100%) invert(52%) sepia(29%) saturate(1548%) hue-rotate(16deg) brightness(94%) contrast(89%)'
            }}
          />
        </motion.div>
      </div>
    </div>
  );
}
